'use client';

import { c as _c } from "react/compiler-runtime";
import { useVaultRoute } from '../../../components/VaultRoute';
import VaultRiskDisclosuresClient from '../VaultRiskDisclosures.client';
import VaultRiskLoading from './VaultRiskLoading';

/**
 * The disclosure comes from static config, so the route loader can render the resolved
 * vault's real text, at its real height, before the page streams.
 */
const VaultRiskDisclosuresRouteLoading = () => {
  const $ = _c(2);
  const route = useVaultRoute();
  let t0;
  if ($[0] !== route) {
    t0 = route ? <VaultRiskDisclosuresClient chainId={route.chainId} address={route.address} /> : <VaultRiskLoading />;
    $[0] = route;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default VaultRiskDisclosuresRouteLoading;